import { render } from "./Sidebar.vue?vue&type=template&id=ca3779ec"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
script.render = render

export default script